<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
      <router-view/>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      transitionName: 'slide-right'
    }
  },
  watch: {
    $route(to, form) {
      let isBack = this.$router.isBack
      if(isBack) {
        this.transitionName = 'slide-right'
      }else{
        this.transitionName = 'slide-left'
      }
      this.$router.isBack = false
    }
  }
}
</script>

<style lang="less">
/* 引入公共less */
@import "./base/less/index.less";
</style>



// WEBPACK FOOTER //
// src/App.vue